module.exports = __webpack_public_path__ + "static/media/e.cosentino.7662f410.svg";